import React from "react";

import classes from "./Toolbar.css";
import Grid from "@material-ui/core/Grid";
import Logo from "../../Logo/Logo";
import NavigationItems from "../NavigationItems/NavigationItems";
import { doLog, getServerAppPath, hasValue } from "../../../shared/utility";

// const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40

function toolbar(props) {
  if (doLog()) console.log("[toolbar] props:", props);
  let agencyCode = "";
  let agencyName = "";
  let agencyAddress = "";
  let baseURL = "";
  // let pathname = "";
  const appPath = "/" + getServerAppPath();
  const logoFilePath = "/images/";
  let logoPath = "";
  let logoName = "";
  let logoWidth = 0;
  let logoHeight = 0;
  let logoSection = null;
  let agencySection = null;

  if (props.configuration !== null) {
    agencyCode = props.agencyCode;
    agencyName = props.configuration.name;
    agencyAddress = props.configuration.addressText;
    baseURL = props.baseURL;
    // pathname = props.pathname;
    logoName = props.configuration.logoName;
    logoWidth = props.configuration.logoWidth;
    logoHeight = props.configuration.logoHeight;
    // if (pathname.startsWith(appPath)) {
    //   logoPath = baseURL + pathname + logoFilePath + logoName;
    // } else {
    //   logoPath = baseURL + appPath + pathname + logoFilePath + logoName;
    // }
    logoPath = baseURL + appPath + logoFilePath + logoName;
    if (doLog()) console.log("[toolbar] appPath:", appPath);
    if (doLog()) console.log("[toolbar] logoName:", logoName);
    if (doLog()) console.log("[toolbar] logoPath:", logoPath);
    if (doLog()) console.log("[toolbar] logoWidth:", logoWidth);

    if (hasValue(logoName) && logoName.length > 0) {
      logoSection = (
        <Grid item xs={12} className={classes.HeaderTitle}>
          <p>
            <Logo logoPath={logoPath} logoWidth={logoWidth} logoHeight={logoHeight} />
          </p>
        </Grid>
      );
    }

    if (agencyCode === "admin") {
      agencySection = (
        <Grid item xs={8} className={classes.Header}>
          <h2 className={classes.HeaderTitle}>
            Welcome to the eCOP Administrator
          </h2>
          <p className={classes.HeaderTitle}>
            Please log in to configure your agency information
          </p>
        </Grid>
      );
    } else if (hasValue(agencyCode)) {
      agencySection = (
        <Grid item xs={8} className={classes.Header}>
          <h2 className={classes.HeaderTitle}>{agencyName}</h2>
          <p className={classes.HeaderTitle}>{agencyAddress}</p>
        </Grid>
      );
    }
  }

  return (
    <header className={classes.Toolbar}>
      <Grid container className={classes.ToolbarGrid}>
        <Grid item xs={2} />
        {/* <Grid item xs={8} className={classes.Header}>
          <h2 className={classes.HeaderTitle}>{agencyName}</h2>
          <p className={classes.HeaderTitle}>{agencyAddress}</p>
        </Grid> */}
        {agencySection}
        <Grid item xs={2}>
          <nav className={classes.DesktopOnly}>
            <NavigationItems
              isAuthenticated={props.isAuth}
              agencyCode={agencyCode}
            />
          </nav>
        </Grid>
      </Grid>
      <Grid container className={classes.ToolbarGrid}>
        {logoSection}
      </Grid>
    </header>
  );
}

export default toolbar;
